import {Injectable} from '@angular/core';
import {IConnectorsEdges, ILayerData, ITagretsNodes,  TGraphType} from '../models/graph-kn.model-interfaces';
import {Stage, StageConfig} from 'konva/lib/Stage';
import {GraphKnEdgeService} from './graph-kn.edge.service';
import {GraphKnDataService} from './graph-kn.data.service';
import {CONTRACT_LAYER_ID, IKnGraphSettings, IStageSettings} from '../models/graph-kn.cm-api-models';
import {GraphKnNodeCreateService} from './graph-kn.node-create.service';
import {KonvaEventObject} from 'konva/lib/Node';
import {GraphKnContextMenuService } from './graph-kn.context-menu.service';

@Injectable({
    providedIn: 'root'
})
export class GraphKnStageService {
	constructor(
		private knNodeCreateService: GraphKnNodeCreateService,
		private knEdgeService: GraphKnEdgeService,
		private knDataService: GraphKnDataService,
		private knContextMenuService: GraphKnContextMenuService,
	) {}
	setStage(stageSettings: IStageSettings) {
        let settings: StageConfig = {
                container: 'graph-container',
                offsetX: stageSettings.offsetX || 0,
                offsetY: stageSettings.offsetY || 0,
                draggable: stageSettings.draggable || true,
                width: stageSettings.width || window.innerWidth - 120,
                height: (stageSettings.height || window.innerHeight) - 5,
        }

            this.knDataService.graphStage?.removeChildren()
            this.knDataService.graphStage?.destroy()
            setTimeout(() => {
                this.knDataService.graphStage = new Stage(settings);
                this.knDataService.graphStage.on('wheel', e => {
                    e = e as KonvaEventObject<WheelEvent, Stage>
                    if (e.evt.ctrlKey === false && this.knDataService.graphStage.y() + e.evt.deltaY * -1 < Math.abs(e.evt.deltaY)) {
                        e.cancelBubble = true
                        this.knDataService.graphStage.move({x: 0, y: e.evt.deltaY * -1})
                    }
                })
            }, 0);

		stageSettings.contextMenu ? 
        this.knContextMenuService.generateContextMenu(this.knDataService.graphStage, document.getElementById('graph-context-menu')) : null
   
	}

	generateStage(
		targetsNodes: ITagretsNodes[], connectorsEdges: IConnectorsEdges[], 
		graphLayerData: ILayerData, graphType: TGraphType = CONTRACT_LAYER_ID,
		graphSettings?:IKnGraphSettings
	) {
		let graphLayer = graphLayerData.layer
		this.knDataService.canvasObjectsMap.set('backGround', {contextMenu: false});
        //Подготовка и отрисовка ребер графа
        this.knEdgeService.createEdgesRoot(connectorsEdges,graphLayer,targetsNodes,graphSettings,graphType)
        this.knNodeCreateService.createNodeRoot(targetsNodes,connectorsEdges,graphLayer,graphType,graphLayerData)

	}
}